import { useEffect, useState } from 'react';
import { activityService } from '@services/api/activityService';
import '../CustomerTabs.css';

interface ComplianceTabProps {
  customerId: string;
}

export const ComplianceTab = ({ customerId }: ComplianceTabProps) => {
  const [activityLog, setActivityLog] = useState<any[]>([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    loadComplianceData();
  }, [customerId]);

  const loadComplianceData = async () => {
    const result = await activityService.getEntityActivity('customer', customerId);
    if (result.success && result.data) {
      setActivityLog(result.data);
    }
    setLoading(false);
  };

  return (
    <div className="tab-content-wrapper">
      <div className="info-card">
        <h3 className="info-card-title">🎯 Risk Profile</h3>
        <p className="text-secondary">Risk assessment integration will be implemented here</p>
      </div>

      <div className="info-card">
        <h3 className="info-card-title">🔍 AML/CFT Screening</h3>
        <p className="text-secondary">Oscilar integration for AML screening results</p>
      </div>

      <div className="info-card">
        <h3 className="info-card-title">📝 Data Access Log</h3>
        {loading ? (
          <p>Loading...</p>
        ) : activityLog.length === 0 ? (
          <p className="text-secondary">No access log entries</p>
        ) : (
          <div className="table-container">
            <table className="table">
              <thead>
                <tr>
                  <th>Timestamp</th>
                  <th>Staff Member</th>
                  <th>Action</th>
                </tr>
              </thead>
              <tbody>
                {activityLog.slice(0, 20).map((log) => (
                  <tr key={log.id}>
                    <td className="text-small">{new Date(log.created_at).toLocaleString()}</td>
                    <td>
                      {log.staff_user?.first_name} {log.staff_user?.last_name} 
                      <span className="text-small text-secondary"> ({log.staff_user?.role})</span>
                    </td>
                    <td className="text-capitalize">{log.action_type.replace(/_/g, ' ')}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}
      </div>
    </div>
  );
};

